var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDashedCircleList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.5H13.75V13.75H18.75V12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15H13.75V16.25H18.75V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.5H13.75V18.75H18.75V17.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H11.25V16.25H12.5V15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H11.25V13.75H12.5V12.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5H11.25V18.75H12.5V17.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25931 5.18312C4.82257 4.51497 5.49758 3.9497 6.25425 3.5125L5.62994 2.43125C4.74714 2.94122 3.95964 3.60067 3.30256 4.38019L4.25931 5.18312Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7407 5.18312L16.6974 4.38019C16.0404 3.60067 15.2529 2.94122 14.3701 2.43125L13.7457 3.5125C14.5024 3.9497 15.1774 4.51497 15.7407 5.18312Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96037 7.4375L1.78712 7.01056C1.43395 7.96778 1.25213 8.97971 1.25 10H2.5C2.50182 9.12543 2.65766 8.25801 2.96037 7.4375Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25931 14.8169C3.69827 14.1468 3.25868 13.3839 2.96037 12.5625L1.78713 12.9894C2.13501 13.948 2.64789 14.8383 3.30256 15.6201L4.25931 14.8169Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0396 7.4375C17.3423 8.25801 17.4982 9.12543 17.5 10H18.75C18.7479 8.97979 18.5661 7.96793 18.2129 7.01081L17.0396 7.4375Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69887 17.3791C7.8379 17.228 7.01034 16.9262 6.25425 16.4875L5.62994 17.5688C6.51204 18.0805 7.47753 18.4326 8.482 18.6087L8.69887 17.3791Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69887 2.62087C9.5588 2.45971 10.4412 2.45971 11.3011 2.62087L11.518 1.391C10.5147 1.203 9.48527 1.203 8.482 1.391L8.69887 2.62087Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashedCircleList);
export default __webpack_public_path__ + "static/media/ic-dashed-circle-list.ac130e8041930d939338e78ec6b75bae.svg";
export { ForwardRef as ReactComponent };